import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AuthService, BaseFilterCollapse, BaseFilterCollapseService, ConfigService } from '../../../../../core';
import { Periodicidade, periodicidadeAnual } from '../../../../../shared';
import { DatepickerComponent, datepickerModePeriodicidade } from '../../../../../shared/components/datepicker';
import { EnumSituacao } from '../../../../../domains/shared/enums/situacao.enum';
import { EnumUsuarioPerfil } from '../../../../../domains/shared/components/usuario-multi-select/enums/usuario-perfil.enum';
import { ConfigEmpresa } from '../../../../configuracoes/app/empresa';
import { Pessoa } from '../../../../pessoa/pessoa';
import { ProdutividadeFilter } from '../../adapters';
import { ProdutividadeFilterStorageService } from './produtividade-filter-storage.service';

@Component({
    selector: 'sgt-produtividade-filter',
    templateUrl: './produtividade-filter.component.html',
    styleUrls: ['./produtividade-filter.component.less']
})
export class ProdutividadeFilterComponent implements BaseFilterCollapse, OnInit, AfterViewInit, OnChanges {
    readonly EnumUsuarioPerfil = EnumUsuarioPerfil;
    readonly EnumSituacao = EnumSituacao;

    filter = new ProdutividadeFilter(null);
    configEmpresa: ConfigEmpresa;
    isAdministrador: boolean;
    isRepresentante: boolean;

    isFilterInitializing = false;
    isFilterInitialized = false;
    /** Quando o filtro estiver inicializado */
    @Output() filterInitialized = new EventEmitter<any>();
    /** Ao alterar algum valor no filtro */
    @Output() filterChange = new EventEmitter<any>();
    /** Ao limpar o filtro */
    @Output() filterClear = new EventEmitter<void>();

    // Data Datepicker
    dataDatepickerMode = datepickerModePeriodicidade.id;
    isFirstChangeData = true;
    @ViewChild('dataDatepicker') dataDatepicker: DatepickerComponent;

    // Filter collapse
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';

    // Multiselects
    isFirstChangeRepresentanteMultiselect = true;
    isFirstChangeClassificacoesClientesMultiselect = true;
    isFirstChangeClassificacoesItensMultiselect = true;

    constructor(private authService: AuthService,
                private baseFilterCollapseService: BaseFilterCollapseService,
                private configService: ConfigService,
                private produtividadeFilterStorageService: ProdutividadeFilterStorageService) { }


    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isAdministrador = this.authService.isAdministrador();
        this.isRepresentante = this.authService.isRepresentante();

        // Aplicando o filtro salvo no storage
        this.filter = this.produtividadeFilterStorageService.get();
        // Iniciando filtro
        this.initFilter();
    }

    ngAfterViewInit() {
        if (!this.isCollapsedInDefault) {
            jQuery(this.filterCollapse.nativeElement).css('display', 'none');
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange()) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    /** Armazena o filtro no storage */
    setStorage() {
        this.produtividadeFilterStorageService.set(this.filter);
    }

    /** Inicializa o filtro */
    private async initFilter() {
        this.isFilterInitializing = true;
        this.isFilterInitialized = false;

        // Setando o mês atual quando o filtro não possuir a periodicidade
        if (!this.filter.periodicidade.hasValue()) {
            await this.setAnoAtual();
        }

        setTimeout(() => {
            this.isFilterInitializing = false;
            this.isFilterInitialized = true;

            // Emitindo o evento de que o filtro foi inicializado
            this.filterInitialized.emit();
        }, 200);
    }

    /** Emite evento de alteração no filtro para atualizar a pesquisa */
    refresh() {
        this.close();
        this.filterChange.emit();
    }

    /** Limpa o filtro e atualiza a pesquisa */
    clear() {
        this.baseFilterCollapseService.clear(this);
        this.filterClear.emit();
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Seta o foco no datepicker da data */
    setFocusDataDatepicker() {
        this.dataDatepicker?.setFocus();
    }

    /** Seta a data do filtro com periodicidade anual e com o ano atual */
    setAnoAtual(): Promise<void> {
        return new Promise<void>(async (resolve) => {
            const data = new Date();
            data.setDate(1); // Setando sempre o dia 1;

            await this.dataDatepicker?.setPeriodicidade(periodicidadeAnual, data);
            resolve();
        })
    }

    /** Seta a periodicidade no filtro da data */
    setAtual(periodicidade: Periodicidade): Promise<void>  {
        return new Promise<void>(async (resolve) => {
            const data = new Date();
            data.setDate(1); // Setando sempre o dia 1;

            await this.dataDatepicker?.setPeriodicidade(periodicidade, data);
            resolve();
        });
    }

    /** Ao alterar a data */
    onChangeData() {
        if (this.isFirstChangeData) {
            this.isFirstChangeData = false;
            return;
        }

        this.filterChange.emit();
    }

    /** Ao alterar a data de início */
    onChangeDataInicio() {
        this.filterChange.emit();
    }

    /** Ao alterar a data de término */
    onChangeDataTermino() {
        this.filterChange.emit();
    }


    /** Ao alterar os representantes */
    onChangeRepresentantes() {
        if (this.isFirstChangeRepresentanteMultiselect) {
            this.isFirstChangeRepresentanteMultiselect = false;
            return;
        }

        this.filterChange.emit();
    }

    /** Ao alterar os atendentes */
    onChangeAtendentes() {
        this.filterChange.emit();
    }

    /** Ao alterar os gerentes */
    onChangeGerentes() {
        this.filterChange.emit();
    }

    /** Ao alterar as classificações de clientes */
    onChangeClassificacoesClientes() {
        if (this.isFirstChangeClassificacoesClientesMultiselect) {
            this.isFirstChangeClassificacoesClientesMultiselect = false;
            return;
        }
        this.filterChange.emit();
    }

    /** Ao alterar as classificações */
    onChangeClassificacoesItens() {
        if (this.isFirstChangeClassificacoesItensMultiselect) {
            this.isFirstChangeClassificacoesItensMultiselect = false;
            return;
        }
        this.filterChange.emit();
    }

    /** Ao selecionar a pessoa do cliente */
    onChangeCliente(pessoa: Pessoa) {
        if (pessoa) {
            this.filter.idPessoa = pessoa.id;
            this.filter.isFilterDirty = true;
        } else {
            this.clearCliente();
        }
    }

    /** Remove a pessoa do cliente */
    clearCliente() {
        this.filter.idPessoa = null;
        this.filter.pessoa = null;
    }

    /** Ao alterar os KPIs */
    onChangeCrossSells() {
        this.filterChange.emit();
    }

    /** Ao alterar o multiselect dos status dos pedidos */
    onChangeStatusesPedidos() {
        this.filterChange.emit();
    }
}
